import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default function({ app, softRedirect }) {
  const user = app && app.$client && app.$client.profile;

  if (!user.hasActiveLoan) {
    return softRedirect(app.localePath(WEB_ROUTES.PROFILE_NO_LOAN));
  }
}
